import { ComponentRowRenderBaseProps, ComponentRowRenderColumn } from '../types'

interface CRRHeaderProps extends ComponentRowRenderBaseProps {
    defaultColumnWidth: number
}

const CRRHeader: React.FC<CRRHeaderProps> = ({ columns, defaultColumnWidth }) => {
    const result: JSX.Element[] = []
    for (const key in columns) {
        const column = columns[key]
        if (column.havePermissions !== false && column.haveModule !== false) {
            result.push(<HeaderItem key={'header_' + (column.dataKey as string) + key} item={column} defaultColumnWidth={defaultColumnWidth} />)
        }
    }
    return (
        <div className='items-center component_row_render_row row_header inline-flex w-full'>
            {result}
        </div>
    )
}

interface HeaderItemProps {
    item: ComponentRowRenderColumn<any>
    defaultColumnWidth: number
}

const HeaderItem: React.FC<HeaderItemProps> = ({item, defaultColumnWidth}) => {
    return (
        <div className={'CRR_header_item ' + (String(item.dataKey)) + ' ' + (item.className || '')} style={{width: item.width || defaultColumnWidth}}>
            {item.label}
        </div>
    )
}

export default CRRHeader